import { render, staticRenderFns } from "./AddNewCilent.vue?vue&type=template&id=f0dec42e&"
import script from "./AddNewCilent.vue?vue&type=script&lang=js&"
export * from "./AddNewCilent.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCilent.vue?vue&type=style&index=0&id=f0dec42e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports